import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import ShopPage from "@/pages/ShopPage";
import ProductDetail from "@/pages/ProductDetail";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderTracking from "@/pages/OrderTracking";
import CustomerAccount from "@/pages/CustomerAccount";
import AdminPanel from "@/pages/AdminPanel";
import DriverPortal from "@/pages/DriverPortal";
import StaffPanel from "@/pages/StaffPanel";
import AuthPage from "@/pages/AuthPage";
import LegalPage from "@/pages/LegalPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { background: '#12151C', color: '#F8FAFC', border: '1px solid rgba(255,255,255,0.1)' },
            }}
          />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/shop/product/:id" element={<ProductDetail />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order/:id" element={<OrderTracking />} />
            <Route path="/account" element={<CustomerAccount />} />
            <Route path="/admin/*" element={<AdminPanel />} />
            <Route path="/driver/*" element={<DriverPortal />} />
            <Route path="/staff/*" element={<StaffPanel />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/terms" element={<LegalPage pageKey="terms" title="Terms of Service" />} />
            <Route path="/privacy" element={<LegalPage pageKey="privacy" title="Privacy Policy" />} />
            <Route path="/delivery-policy" element={<LegalPage pageKey="delivery_policy" title="Delivery Policy" />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
